import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  Progress,
  Row,
  Space,
  Spin,
  Statistic,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  getBanks,
  getKpiCashFlow,
  getKpiCashFlowCompany,
} from "services/dashboard/dashboard-service";
import { notificationErroInternal, notificationInfo } from "util/api-utils";
import { formatCurrency, formatCurrencyWithoutRS } from "util/format";
import FusionCharts from "fusioncharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.gammel";
import ReactFC from "react-fusioncharts";
import ReactFusioncharts from "react-fusioncharts";
import * as Widgets from "fusioncharts/fusioncharts.widgets.js";
import {
  mountChartIncome,
  mountChartLine,
  mountChartMultLine,
  mountChartPie,
  mountChartProfit,
  mountChartProfitBar,
  mountWaterFall,
} from "./func-chart-profit";
import { mountChartReceivedCompany } from "./func-chart-received-company";
import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  getCashFlow,
  getIncomeV2,
  getStatus,
} from "services/client/client-service";
import { CSVLink } from "react-csv";
import { ColumnsCashFlowLate, getMonthNames } from "./columns-table-kpi";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  Bar,
  Line,
  YAxis,
  AreaChart,
  Area,
  BarChart,
  ReferenceLine,
} from "recharts";

dayjs.extend(customParseFormat);
const dateFormat = "MM/YYYY";
ReactFC.fcRoot(FusionCharts, FusionTheme, Widgets);
FusionCharts.options["license"] = false;
const { info } = Modal;
const { RangePicker } = DatePicker;
const padColor = "#EC6D62";
const receiveColor = "#0071FF";
const profitColor = "#FF9900";
import {
  CalendarDays,
  ArrowRight,
  Percent,
  ChartColumn,
  ClipboardPaste,
  ChevronDown,
  LandPlot,
  History,
  EyeOff,
  Circle,
  FileInput,
  Maximize,
  Layers2,
  GitMerge,
  ArrowDownToLine,
  SlidersHorizontal,
} from "lucide-react";
const { Text } = Typography;

const font = '"Montserrat", sans-serif';

const COLORS = ["#0071FF", "#E0E0E0"];
const COLORS_PAID = ["#EC6D62", "#E0E0E0"];

const gradientOffset = (kpiAmountFinal) => {
  const dataMax = Math.max(...kpiAmountFinal.map((i) => i.amount));
  const dataMin = Math.min(...kpiAmountFinal.map((i) => i.amount));

  if (dataMax <= 0) {
    return 0;
  }
  if (dataMin >= 0) {
    return 1;
  }

  return dataMax / (dataMax - dataMin);
};
const off = (kpiAmountFinal) => gradientOffset(kpiAmountFinal);

const renderCustomizedLabel = ({ cx, cy, percent, index }) => {
  if (index != 0) {
    return "";
  }
  return (
    <text
      x={cx}
      y={cy}
      fill="black"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize="24px"
    >
      {`${(percent * 100).toFixed(2).replace(".", ",")}%`}
    </text>
  );
};
const renderCustomizedLabelCost = ({ cx, cy, percent, index }) => {
  return (
    <text
      x={cx}
      y={cy}
      fill="black"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize="24px"
    >
      {`${(100).toFixed(2).replace(".", ",")}%`}
    </text>
  );
};
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#fff",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontFamily: font,
        }}
      >
        <p className="intro">{`Mês: ${label}`}</p>
        <p className="intro">
          Despesa:{" "}
          <span style={{ color: padColor }}>
            {formatCurrency(payload[0].value)}
          </span>
        </p>
        <p className="intro">
          Receita:{" "}
          <span style={{ color: receiveColor }}>
            {formatCurrency(payload[1].value)}
          </span>
        </p>
        <p className="intro">
          Lucro Operacional:{" "}
          <span style={{ color: profitColor }}>
            {formatCurrency(payload[2].value)}
          </span>
        </p>
      </div>
    );
  }

  return null;
};
const CustomTooltipMonth = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#fff",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontFamily: font,
        }}
      >
        <p className="intro">{`Mês: ${label}`}</p>
        <p className="intro">
          Saldo:{" "}
          <span style={{ color: profitColor }}>
            {formatCurrency(payload[0].value)}
          </span>
        </p>
      </div>
    );
  }

  return null;
};
const CustomTooltipDre = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#fff",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontFamily: font,
        }}
      >
        <p className="intro">{`${payload[0].payload.grupo}`}</p>
        <p className="intro">
          <span style={{ color: payload[0].value < 0 ? "#EC6D62" : "#0071FF" }}>
            {formatCurrency(payload[0].value)}
          </span>
        </p>
      </div>
    );
  }

  return null;
};
const KpiCashFlowV2 = () => {
  const [data, setData] = useState({
    sumByMonth: [],
    costKpi: [],
    cashFlowYear: [],
    costKpiAll: [],
  });
  const [filterStartDate, setStartDate] = useState(moment().format(dateFormat));
  const [loading, setLoading] = useState(false);
  const [filterEndDate, setEndDate] = useState(moment().format(dateFormat));
  const [banks, setBanks] = useState([]);
  const [filterBanks, setFilterBanks] = useState([]);
  const [status, setStatus] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [dataIncome, setDataIncome] = useState([]);
  const [loadingIncome, setLoadingIcome] = useState(false);
  const [dataCost, setDataCost] = useState([]);
  const [margin, setMargin] = useState(0);
  const [profit, setProfit] = useState(0);
  const [percentProfit, setPercentProfit] = useState(0);
  const [loadingKpi, setLoadingKpi] = useState(false);
  const [loadingCash, setLoadingCash] = useState(false);

  const [filterStartDateYear, setStartDateYear] = useState(
    moment(moment().year() + "-01").format(dateFormat)
  );
  const [filterEndDateYear, setEndDateYear] = useState(
    moment(moment().year() + "-12").format(dateFormat)
  );

  const [kpiReveueAndExpense, setKpiReveueAndExpense] = useState([]);
  const [kpiAmountFinal, setKpiAmountFinal] = useState([]);

  useEffect(() => {
    setLoading(true);

    getStatus().then((res) => {
      let selectStatus = res.map((obj) => ({
        value: obj.name,
        label: obj.name,
      }));
      let resIdStatus = res.map((item) => item.name);

      let resIdStatusCash = res
        .filter((f) => f.name != "Atrasado" && f.name != "Cancelado")
        .map((item) => item.name);

      setFilterStatus(resIdStatus);
      setStatus(selectStatus);
      getBanks().then((res) => {
        let selectBank = res.map((obj) => ({
          value: obj.codeAccount,
          label: obj.description,
        }));

        let resIdBank = res.map((item) => item.codeAccount);
        resIdBank.push("WITHOUT_BANK");

        let resIdBankCash = res
          .filter((item) => item.sumAmount == true)
          .map((item) => item.codeAccount);
        resIdBank.push("WITHOUT_BANK");

        setFilterBanks(resIdBank);
        setBanks(selectBank);

        getMappingDataIncome(resIdStatus, resIdBank);
        getMappingDataIncomeYear(resIdStatus, resIdBank);
        getMappingDataCash(resIdStatusCash, resIdBankCash);
      });
    });

    getMappingData();
  }, []);

  function getMappingDataCash(filterStatus, filterBanks) {
    setLoadingCash(true);
    const filter = {
      start: filterStartDateYear,
      end: filterEndDateYear,
      status: filterStatus,
      banks: filterBanks,
    };
    getCashFlow(filter)
      .then((res) => {
        const amountFinal = [];
        const cash = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "SALDO FINAL"
        );

        if (cash.length == 1) {
          cash[0].amountMonth.forEach((element) => {
            var name = element.month.substring(0, 3);
            name = name.replace("JAN", "Jan");
            name = name.replace("FEB", "Fev");
            name = name.replace("MAR", "Mar");
            name = name.replace("APR", "Abr");
            name = name.replace("MAY", "Mai");
            name = name.replace("JUN", "Jun");
            name = name.replace("JUL", "Jul");
            name = name.replace("AUG", "Ago");
            name = name.replace("SEP", "Set");
            name = name.replace("OCT", "Out");
            name = name.replace("NOV", "Nov");
            name = name.replace("DEC", "Dez");

            amountFinal.push({
              duaDateMonth: name,
              amount: element.profit,
            });
          });
        }
        setLoadingCash(false);
        setKpiAmountFinal(amountFinal);
      })
      .catch((err) => {
        setLoadingCash(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  function getMappingData() {
    if (filterEndDate == null || filterEndDate == null) {
      notificationInfo("É nescesário informar o mês inicial e final.");
      return;
    }
    const filter = {
      start: filterStartDate,
      end: filterEndDate,
    };
    getKpiCashFlow(filter)
      .then((res) => {
        setData(res);
        let list = [];

        res.costKpi
          .filter((it) => it.isTotal == true)
          .forEach((item) => {
            list.push({ ...item, showChildren: false });
          });
        setDataCost(list);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function getMappingDataIncome(filterStatus, filterBanks) {
    setLoadingIcome(true);
    setLoading(true);
    if (filterEndDate == null || filterEndDate == null) {
      setLoadingIcome(false);
      setLoading(false);
      return;
    }
    const filter = {
      start: filterStartDate,
      end: filterEndDate,
      status: filterStatus,
      banks: filterBanks,
      type: "COMPETENCE",
    };
    getIncomeV2(filter)
      .then((res) => {
        const margem = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "MARGEM BRUTA"
        );
        const receive = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "RECEITA LÍQUIDA"
        );

        const profit = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "RESULTADO OPERACIONAL"
        );
        const receiveBruto = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "RECEITA BRUTA"
        );

        let percent = (margem[0]?.total * 100) / receive[0]?.total;

        let profitValue = profit[0]?.total;
        let profitValuePercent =
          (profit[0]?.total * 100) / receiveBruto[0]?.total;

        setMargin(percent);
        setProfit(profitValue);
        setPercentProfit(profitValuePercent);
        setLoading(false);

        let dataIncome = res.filter((item) => item.is_total);

        getMappingDataIncomeLastMonth(filterStatus, filterBanks, dataIncome);
      })
      .catch((err) => {
        setLoadingIcome(false);
        setLoading(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function getMappingDataIncomeYear(filterStatus, filterBanks) {
    setLoadingKpi(true);
    const filter = {
      start: filterStartDateYear,
      end: filterEndDateYear,
      status: filterStatus,
      banks: filterBanks,
      type: "COMPETENCE",
    };
    getIncomeV2(filter)
      .then((res) => {
        const kpiReveueAndExpense = [];
        const receive = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "RECEITA BRUTA"
        );
        const expenses = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "DESPESAS OPERACIONAIS"
        );

        const tax = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "IMPOSTOS"
        );

        const custos = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "CUSTOS"
        );

        const profit = res.filter(
          (f) => f.grupo.toUpperCase().trim() == "RESULTADO OPERACIONAL"
        );
        const months = [
          { name: "Jan", key: "janeiro" },
          { name: "Fev", key: "fevereiro" },
          { name: "Mar", key: "marco" },
          { name: "Abr", key: "abril" },
          { name: "Mai", key: "maio" },
          { name: "Jun", key: "junho" },
          { name: "Jul", key: "julho" },
          { name: "Ago", key: "agosto" },
          { name: "Set", key: "setembro" },
          { name: "Out", key: "outubro" },
          { name: "Nov", key: "novembro" },
          { name: "Dez", key: "dezembro" },
        ];

        months.forEach((month) => {
          kpiReveueAndExpense.push({
            month: month.name,
            revenue: receive[0]?.[month.key] || 0,
            expense:
              (expenses[0]?.[month.key] || 0) +
              (tax[0]?.[month.key] || 0) +
              (custos[0]?.[month.key] || 0),
            profit: profit[0]?.[month.key] || 0,
          });
        });

        setKpiReveueAndExpense(kpiReveueAndExpense);
        setLoadingKpi(false);
      })
      .catch((err) => {
        setLoadingKpi(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function getMappingDataIncomeLastMonth(
    filterStatus,
    filterBanks,
    dataIncome
  ) {
    setLoadingIcome(true);
    let start = moment(
      filterStartDate.substring(3) + "-" + filterStartDate.substring(0, 2)
    );
    let end = moment(
      filterEndDate.substring(3) + "-" + filterEndDate.substring(0, 2)
    );
    start = start.subtract(1, "months");
    end = end.subtract(1, "months");

    const filterStart = start.format(dateFormat);
    const filterEnd = start.format(dateFormat);

    const filter = {
      start: filterStart,
      end: filterEnd,
      status: filterStatus,
      banks: filterBanks,
      type: "COMPETENCE",
    };
    getIncomeV2(filter)
      .then((res) => {
        let dataIncomeLast = res.filter((item) => item.is_total);
        const receive = dataIncome.filter(
          (f) => f.grupo.toUpperCase().trim() == "RECEITA LÍQUIDA"
        );

        dataIncome.forEach((item) => {
          let percent = (item?.total * 100) / receive[0]?.total;

          let amountLastMonth = dataIncomeLast.filter(
            (lastItem) => lastItem.grupo == item.grupo
          );

          let percentLastMonth =
            (amountLastMonth[0]?.total * 100) / receive[0]?.total;

          item.percentLastMonth =
            formatCurrencyWithoutRS(percentLastMonth.toFixed(2)) + "%";
          item.percent = formatCurrencyWithoutRS(percent.toFixed(2)) + "%";
        });

        setDataIncome(dataIncome);
        setLoadingIcome(false);
      })
      .catch((err) => {
        setLoadingIcome(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const refreshData = () => {
    setLoading(true);
    setPercentProfit(0);
    setProfit(0);

    getMappingData();
    getMappingDataIncome(filterStatus, filterBanks);
    //getMappingDataIncomeYear(filterStatus, filterBanks);
  };

  const setFilterStartDateRange = (e) => {
    if (e == null) {
      setStartDate(null);
      setEndDate(null);
    } else {
      setStartDate(e[0].format(dateFormat));
      setEndDate(e[1].format(dateFormat));
    }
  };
  const setFilterStartDate = (e) => {
    if (e == null) {
      setStartDate(moment().format(dateFormat));
    } else {
      setStartDate(e.format(dateFormat));
    }
  };
  const setFilterEndDate = (e) => {
    if (e == null) {
      setEndDate(moment().format(dateFormat));
    } else {
      setEndDate(e.format(dateFormat));
    }
  };
  const columnsCost = [
    {
      title: "Contas",
      dataIndex: "name",
      key: "name",
      label: "Contas",
      render(text, record) {
        let margin = record.isTotal ? "0px" : "10px";
        let fontWeight = record.isTotal ? "bold" : "initial";

        return {
          children: (
            <div
              style={{
                marginLeft: margin,
                fontWeight: fontWeight,
                cursor: "pointer",
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },

    {
      title: "Valor",
      dataIndex: "value",
      key: "value",
      label: "Valor",
      render(text, record) {
        let fontWeight = record.isTotal ? "bold" : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
                cursor: "pointer",
              }}
            >
              {formatCurrency(text)}
            </div>
          ),
        };
      },
    },
    {
      title: "%",
      dataIndex: "percent",
      key: "percent",
      label: "%",
      render(text, record) {
        let fontWeight = record.isTotal ? "bold" : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text + "%"}
            </div>
          ),
        };
      },
    },
  ];
  const columns = [
    {
      title: "Grupo",
      dataIndex: "grupo",
      key: "grupo",
      label: "Grupo",
      render(text, record) {
        let fontWeight =
          record.grupo == "MARGEM BRUTA" ||
          record.grupo == "RESULTADO OPERACIONAL" ||
          record.grupo == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },
    {
      title: "Valor",
      dataIndex: "total",
      key: "total",
      label: "Despesa",

      render(text, record) {
        let fontWeight =
          record.grupo == "MARGEM BRUTA" ||
          record.grupo == "RESULTADO OPERACIONAL" ||
          record.grupo == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {formatCurrency(text)}
            </div>
          ),
        };
      },
    },
    {
      title: "% Mês Atual",
      dataIndex: "percent",
      key: "percent",
      label: "% Mês Atual",
      render(text, record) {
        let fontWeight =
          record.grupo == "MARGEM BRUTA" ||
          record.grupo == "RESULTADO OPERACIONAL" ||
          record.grupo == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";
        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },
    {
      title: "% Mês Anterior",
      dataIndex: "percentLastMonth",
      key: "percentLastMonth",
      label: "% Mês Anterior",
      render(text, record) {
        let fontWeight =
          record.grupo == "MARGEM BRUTA" ||
          record.grupo == "RESULTADO OPERACIONAL" ||
          record.grupo == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";
        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },
  ];

  const columnsBalance = [
    {
      title: "Mês",
      dataIndex: "monthDate",
      key: "monthDate",
      label: "Mês",
    },
    {
      title: "Receita",
      dataIndex: "revenue",
      key: "revenue",
      label: "Receita",
      render: (text) => {
        return formatCurrency(text);
      },
    },
    {
      title: "Despesa",
      dataIndex: "expense",
      key: "expense",
      label: "Despesa",
      render: (text) => {
        return formatCurrency(text);
      },
    },
    {
      title: "Ponto de equilíbrio",
      label: "Ponto de equilíbrio",
      dataIndex: "balance",
      key: "balance",
      render: (text) => {
        return formatCurrency(text);
      },
    },
  ];

  let dataMargin = margin;

  let colorMargin = "#2A8DEB";
  let prefixMargin = "";
  if (dataMargin < 0) {
    dataMargin = dataMargin * -1;
    prefixMargin = "-";
    colorMargin = "#ED5E80";
  }
  let revenuePercent = data.budgetRevenuePercent;
  if (revenuePercent > 100) {
    revenuePercent = 100;
  }

  let expensePercent = data.budgetExpensePercent;
  if (expensePercent > 100) {
    expensePercent = 100;
  }

  function showConfirm(title, div, icon) {
    info({
      title: (
        <span style={{ fontFamily: font }}>
          {icon}
          {title}
        </span>
      ),
      icon: null,
      content: div,
      width: "90%",
      centered: true,
      getContainer() {},
      onOk() {},
    });
  }

  function showAllCashFlowLate(data) {
    info({
      title: <div style={{ textAlign: "center" }}>Inadimplentes</div>,
      icon: null,
      content: (
        <div style={{ textAlign: "center" }}>
          <Table
            columns={ColumnsCashFlowLate}
            dataSource={data}
            pagination={{ pageSize: 5 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </div>
      ),
      width: "50%",
      centered: true,
      onOk() {},
    });
  }
  const chartReceivePaid = () => {
    return (
      <ResponsiveContainer
        width="100%"
        height={400}
        style={{ fontFamily: font }}
      >
        <ComposedChart
          data={kpiReveueAndExpense}
          margin={{ top: 20, right: 30, left: 50, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis tickFormatter={(value) => formatCurrency(value)} />

          <Tooltip content={<CustomTooltip />} />
          <Legend align="left" />
          <Bar name="Despesa" dataKey="expense" fill={padColor} />
          <Bar name="Receita" dataKey="revenue" fill={receiveColor} />
          <Line
            name="Lucro Operacional"
            type="monotone"
            dataKey="profit"
            stroke={profitColor}
          />
        </ComposedChart>
      </ResponsiveContainer>
    );
  };
  const chartMonth = () => {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <AreaChart
          width={500}
          height={400}
          data={kpiAmountFinal}
          margin={{
            top: 20,
            right: 30,
            left: 50,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="duaDateMonth" />
          <YAxis tickFormatter={(value) => formatCurrency(value)} />
          <Tooltip content={<CustomTooltipMonth />} />
          <defs>
            <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset={off(kpiAmountFinal)}
                stopColor="#0071FF"
                stopOpacity={1}
              />
              <stop
                offset={off(kpiAmountFinal)}
                stopColor="#EC6D62"
                stopOpacity={1}
              />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="amount"
            stroke="#000"
            fill="url(#splitColor)"
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  };
  const chartCost = () => {
    return (
      <div>
        {" "}
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={[data.costKpi[0], data.costKpi[1]]}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={90}
              startAngle={90}
              endAngle={-270}
              fill="#0071FF"
              paddingAngle={5}
              dataKey="percent"
              labelLine={false}
              label={renderCustomizedLabelCost}
            >
              {data.costKpi?.slice(1).map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <Row
          style={{ textAlign: "center", marginTop: "30px", marginLef: "2px" }}
        >
          <Text strong style={{ fontSize: "14px", fontFamily: font }}>
            <Circle
              size={15}
              color="#0071FF"
              style={{ marginBottom: "-3px", marginRight: "5px" }}
            />
            Fixo
          </Text>
          <Text
            style={{
              fontSize: "14px",
              fontFamily: font,
              marginLeft: "10px",
            }}
          >
            {data.costKpi && (
              <div>
                {formatCurrency(data.costKpi[0]?.value)} -{" "}
                {data.costKpi[0]?.percent.toString().replace(".", ",")}%
              </div>
            )}
          </Text>
        </Row>
        <Row style={{ textAlign: "center", marginTop: "30px" }}>
          <Text strong style={{ fontSize: "14px", fontFamily: font }}>
            <Circle
              size={15}
              color="#E0E0E0"
              style={{ marginBottom: "-3px", marginRight: "5px" }}
            />
            Variável
          </Text>
          <Text
            style={{
              fontSize: "14px",
              fontFamily: font,
              marginLeft: "10px",
            }}
          >
            {data.costKpi && (
              <div>
                {formatCurrency(data.costKpi[1]?.value)} -{" "}
                {data.costKpi[1]?.percent.toString().replace(".", ",")}%
              </div>
            )}
          </Text>
        </Row>
      </div>
    );
  };
  const chartDre = () => {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          stackOffset="sign"
          data={dataIncome}
          margin={{
            top: 30,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="grupo" padding={{ left: 30, right: 30 }} />

          <YAxis tickFormatter={(value) => formatCurrency(value)} />
          <Tooltip content={<CustomTooltipDre />} />
          <ReferenceLine y={0} stroke="#000" />

          <Bar dataKey="total" stackId="a">
            {dataIncome.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.total < 0 ? "#EC6D62" : "#0071FF"}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  };
  return (
    <div className="cash-flow-v2">
      <Spin size="large" spinning={loading}>
        <Space>
          <RangePicker
            defaultValue={[
              dayjs(filterStartDate, dateFormat),
              dayjs(filterEndDate, dateFormat),
            ]}
            placeholder={["Mês Inicial", "Mês Final"]}
            format={dateFormat}
            picker="month"
            suffixIcon={<CalendarDays size={18} />}
            onChange={setFilterStartDateRange}
          />

          <Button
            style={{ fontFamily: font }}
            type="primary"
            icon={
              <ArrowRight
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={refreshData}
          >
            Filtrar
          </Button>
        </Space>

        <Row
          gutter={[24, 24]}
          style={{ marginTop: "20px" }}
          className="card-total"
          justify="space-between"
        >
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Percent
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Margem Bruta
                    </Text>
                  </div>
                </div>
              }
              style={{ height: "404px" }}
              bordered={false}
            >
              <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Pie
                    data={[
                      { name: "Margem Bruta", value: dataMargin },
                      { name: "Restante", value: 100 - dataMargin },
                    ]}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={90}
                    startAngle={90}
                    endAngle={-270}
                    fill="#0071FF"
                    paddingAngle={5}
                    dataKey="value"
                    labelLine={false}
                    label={renderCustomizedLabel}
                  >
                    {[
                      { name: "Margem Bruta", value: dataMargin },
                      { name: "Restante", value: 100 - dataMargin },
                    ].map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div style={{ textAlign: "center", marginTop: "30px" }}>
                <Text strong style={{ fontSize: "14px", fontFamily: font }}>
                  <Circle
                    size={15}
                    color="#0071FF"
                    style={{ marginBottom: "-3px", marginRight: "5px" }}
                  />{" "}
                  Margem Bruta
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    fontFamily: font,
                    marginLeft: "10px",
                  }}
                >
                  {dataMargin.toFixed(2).replace(".", ",")}%
                </Text>
              </div>
            </Card>
          </Space>
          <Space direction="vertical" size={"small"}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <ChartColumn
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Total Receita
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(data.revenue)}
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  &nbsp;
                </Text>
              </Row>
            </Card>

            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <ClipboardPaste
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Contas a Receber
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(data.billReceive)}
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Prazo médio: {formatCurrencyWithoutRS(
                    data.averageReceive
                  )}{" "}
                  dias
                </Text>
              </Row>
            </Card>
          </Space>

          <Space direction="vertical" size={"small"}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <ChevronDown
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Total Despesa
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#FF3B30",
                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(data.expense)}
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  &nbsp;
                </Text>
              </Row>
            </Card>

            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <ClipboardPaste
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Contas a Pagar
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#FF3B30",

                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(data.billPaid)}
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Prazo médio: {formatCurrencyWithoutRS(
                    data.averagePaidDaly
                  )}{" "}
                  dias
                </Text>
              </Row>
            </Card>
          </Space>

          <Space direction="vertical" size={"small"}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <LandPlot
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Lucro Operacional
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#007AFF",
                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(profit)}
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  &nbsp;
                </Text>
              </Row>
            </Card>

            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <History
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Saldo no mês
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(data.amountMonth)}
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  &nbsp;
                </Text>
              </Row>
            </Card>
          </Space>

          <Space direction="vertical" size={"small"}>
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Percent
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Lucro Operacional
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(percentProfit)}%
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  Lucro operacional / Receita bruta
                </Text>
              </Row>
            </Card>

            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <EyeOff
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Inadimplentes
                    </Text>
                  </div>
                </div>
              }
              onClick={
                data.billReceiveLast == 0
                  ? () => {}
                  : () => showAllCashFlowLate(data.listLateReceive)
              }
              style={{
                cursor: data.billReceiveLast == 0 ? "none" : "pointer",
              }}
              bordered={false}
            >
              <Row style={{ paddingBottom: "10px" }}>
                <Text
                  style={{
                    fontFamily: font,
                    fontSize: "40px",
                  }}
                >
                  {formatCurrencyWithoutRS(data.billReceiveLate)}
                </Text>
              </Row>
              <Row>
                <Text
                  style={{
                    fontFamily: font,
                    color: "#9FA1AA",
                    fontSize: "14px",
                  }}
                >
                  &nbsp;
                </Text>
              </Row>
            </Card>
          </Space>
        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: "15px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px" }}
          >
            <Spin spinning={loadingKpi}>
              <Card
                title={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <FileInput
                        size={18}
                        style={{ marginBottom: "-4px", marginRight: "10px" }}
                      />
                      <Text style={{ fontSize: "14px", fontFamily: font }}>
                        Receita e Despesa
                      </Text>
                    </div>
                    <Button
                      onClick={() =>
                        showConfirm(
                          "Receita e Despesa",
                          chartReceivePaid(),
                          <FileInput
                            size={20}
                            style={{
                              marginRight: "10px",
                              marginBottom: "-3px",
                            }}
                          />
                        )
                      }
                      style={{ fontFamily: font, marginLeft: "10px" }}
                    >
                      <Maximize size={20} />
                    </Button>
                  </div>
                }
                style={{ width: "100%" }}
              >
                {chartReceivePaid()}
              </Card>
            </Spin>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ minWidth: "450px" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Percent
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      {data.showBuget && "Orçamento da receita"}
                      {!data.showBuget && "Receita mês anterior"}
                    </Text>
                  </div>
                </div>
              }
              style={{ height: "505px" }}
              bordered={false}
            >
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={[
                      {
                        name: "Realizado",
                        value: data.showBuget
                          ? revenuePercent
                          : data.revenuePercentLast,
                      },
                      {
                        name: "Restante",
                        value:
                          100 -
                          (data.showBuget
                            ? revenuePercent
                            : data.revenuePercentLast),
                      },
                    ]}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={90}
                    startAngle={90}
                    endAngle={-270}
                    fill="#0071FF"
                    paddingAngle={5}
                    dataKey="value"
                    labelLine={false}
                    label={renderCustomizedLabel}
                  >
                    {[
                      {
                        name: "Realizado",
                        value: data.showBuget
                          ? revenuePercent
                          : data.revenuePercentLast,
                      },
                      {
                        name: data.showBuget ? "Orçado" : "Mês Anterior",
                        value:
                          100 -
                          (data.showBuget
                            ? revenuePercent
                            : data.revenuePercentLast),
                      },
                    ].map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div style={{ textAlign: "center", marginTop: "30px" }}>
                <Text strong style={{ fontSize: "14px", fontFamily: font }}>
                  {data.showBuget && "Orçado"}
                  {!data.showBuget && "Mês anterior"}
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    fontFamily: font,
                    marginLeft: "10px",
                  }}
                >
                  {data.showBuget && formatCurrency(data.budgetRevenue)}
                  {!data.showBuget && formatCurrency(data.billReceiveLast)}
                </Text>
              </div>
              <div style={{ textAlign: "center", marginTop: "30px" }}>
                <Text strong style={{ fontSize: "14px", fontFamily: font }}>
                  <Circle
                    size={15}
                    color="#0071FF"
                    style={{ marginBottom: "-3px", marginRight: "5px" }}
                  />{" "}
                  Realizado
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    fontFamily: font,
                    marginLeft: "10px",
                  }}
                >
                  {formatCurrency(data.revenue)}
                </Text>
              </div>
            </Card>
          </Space>
        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: "15px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px" }}
          >
            <Spin spinning={loadingKpi}>
              <Card
                title={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <ChartColumn
                        size={18}
                        style={{ marginBottom: "-4px", marginRight: "10px" }}
                      />
                      <Text style={{ fontSize: "14px", fontFamily: font }}>
                        Saldo no fim do mês
                      </Text>
                    </div>
                    <Button
                      onClick={() =>
                        showConfirm(
                          "Saldo no fim do mês",
                          chartMonth(),
                          <ChartColumn
                            size={20}
                            style={{
                              marginRight: "10px",
                              marginBottom: "-3px",
                            }}
                          />
                        )
                      }
                      style={{ fontFamily: font, marginLeft: "10px" }}
                    >
                      <Maximize size={20} />
                    </Button>
                  </div>
                }
                style={{ width: "100%" }}
              >
                {chartMonth()}
              </Card>
            </Spin>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ minWidth: "450px" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Percent
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      {data.showBuget && "Orçamento da despesa"}
                      {!data.showBuget && "Despesa mês anterior"}
                    </Text>
                  </div>
                </div>
              }
              style={{ height: "505px" }}
              bordered={false}
            >
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={[
                      {
                        name: "Realizado",
                        value: data.showBuget
                          ? expensePercent
                          : data.paidPercentLast,
                      },
                      {
                        name: "Restante",
                        value:
                          100 -
                          (data.showBuget
                            ? expensePercent
                            : data.paidPercentLast),
                      },
                    ]}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={90}
                    startAngle={90}
                    endAngle={-270}
                    fill="#EC6D62"
                    paddingAngle={5}
                    dataKey="value"
                    labelLine={false}
                    label={renderCustomizedLabel}
                  >
                    {[
                      {
                        name: "Realizado",
                        value: data.showBuget
                          ? expensePercent
                          : data.paidPercentLast,
                      },
                      {
                        name: data.showBuget ? "Orçado" : "Mês Anterior",
                        value:
                          100 -
                          (data.showBuget
                            ? expensePercent
                            : data.paidPercentLast),
                      },
                    ].map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS_PAID[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div style={{ textAlign: "center", marginTop: "30px" }}>
                <Text strong style={{ fontSize: "14px", fontFamily: font }}>
                  {data.showBuget && "Orçado"}
                  {!data.showBuget && "Mês anterior"}
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    fontFamily: font,
                    marginLeft: "10px",
                  }}
                >
                  {data.showBuget && formatCurrency(data.budgetExpense)}
                  {!data.showBuget && formatCurrency(data.billPaidLast)}
                </Text>
              </div>
              <div style={{ textAlign: "center", marginTop: "30px" }}>
                <Text strong style={{ fontSize: "14px", fontFamily: font }}>
                  <Circle
                    size={15}
                    color="#EC6D62"
                    style={{ marginBottom: "-3px", marginRight: "5px" }}
                  />{" "}
                  Realizado
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    fontFamily: font,
                    marginLeft: "10px",
                  }}
                >
                  {formatCurrency(data.expense)}
                </Text>
              </div>
            </Card>
          </Space>
        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: "15px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "50%" }}
          >
            <Spin spinning={loadingIncome}>
              <Card
                title={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <Layers2
                        size={18}
                        style={{ marginBottom: "-4px", marginRight: "10px" }}
                      />
                      <Text style={{ fontSize: "14px", fontFamily: font }}>
                        Demonstrativo de resultados
                      </Text>
                    </div>
                    <Button
                      onClick={() =>
                        showConfirm(
                          "Demonstrativo de resultados",
                          chartDre(),
                          <Layers2
                            size={20}
                            style={{
                              marginRight: "10px",
                              marginBottom: "-3px",
                            }}
                          />
                        )
                      }
                      style={{ fontFamily: font, marginLeft: "10px" }}
                    >
                      <Maximize size={20} />
                    </Button>
                  </div>
                }
                style={{ width: "100%" }}
              >
                {chartDre()}
              </Card>
            </Spin>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "50%" }}
          >
            <Card
              id="card-table"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <GitMerge
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Demonstrativo de resultados
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Demonstrativo de resultados",
                        <Table
                          size="small"
                          loading={loadingIncome}
                          columns={columns}
                          pagination={false}
                          dataSource={dataIncome}
                        />,
                        <GitMerge
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                  <CSVLink
                    filename={"Demonstrativo de resultados.csv"}
                    data={dataIncome}
                    headers={columns}
                  >
                    <Button style={{ marginLeft: "10px" }}>
                      <ArrowDownToLine size={20} />
                    </Button>
                  </CSVLink>
                </div>
              }
              style={{ height: "505px" }}
              bordered={false}
            >
              <div style={{ overflowX: "auto", height: 445 }}>
                <Table
                  size="small"
                  loading={loadingIncome}
                  columns={columns}
                  pagination={false}
                  dataSource={dataIncome}
                />
              </div>
            </Card>
          </Space>
        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: "15px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "50%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <SlidersHorizontal
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "14px", fontFamily: font }}>
                      Custo Fixo e Variável
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Custo Fixo e Variável",
                        chartCost(),
                        <SlidersHorizontal
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              style={{ width: "100%" }}
            >
              {chartCost()}
            </Card>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "50%" }}
          >
            <Card
              id="card-table"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <SlidersHorizontal
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Custo Fixo e Variável
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Custo Fixo e Variável",
                        <Table
                          size="small"
                          columns={columnsCost}
                          pagination={false}
                          dataSource={data.costKpiAll}
                        />,
                        <SlidersHorizontal
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                  <CSVLink
                    filename={"Custo Fixo e Variável.csv"}
                    data={data.costKpiAll}
                    headers={columnsCost}
                  >
                    <Button style={{ marginLeft: "10px" }}>
                      <ArrowDownToLine size={20} />
                    </Button>
                  </CSVLink>
                </div>
              }
              style={{ height: "505px" }}
              bordered={false}
            >
              <div style={{ overflowX: "auto", height: 445 }}>
                <Table
                  size="small"
                  pagination={false}
                  columns={columnsCost}
                  dataSource={dataCost}
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: (event) => {
                        let list = [];

                        data.costKpi.forEach((item) => {
                          let showChildren = dataCost
                            .filter((key) => key.name == item.name)
                            .map((obj) => obj.showChildren)[0];
                          if (item.name == record.name) {
                            showChildren = !record.showChildren;
                          }

                          list.push({
                            ...item,
                            showChildren: showChildren,
                          });
                          if (showChildren && item.values) {
                            item.values.forEach((children) => {
                              list.push({
                                ...children,
                              });
                            });
                          }
                        });
                        setDataCost(list);
                      }, // click row
                    };
                  }}
                />
              </div>
            </Card>
          </Space>
        </Row>
      </Spin>
      {/*
            <Row gutter={[16, 16]} style={{ marginTop: " 25px;" }}>
              <Col span={12}>
                <div className="container-card">
                  <div className="card-default" style={{ minHeight: "340px" }}>
                    <Space>
                      <div>Ponto de equilíbrio</div>
                      <Button
                        type="link"
                        onClick={() =>
                          showConfirm(
                            "Ponto de equilíbrio",
                            <ReactFusioncharts
                              type="msline"
                              width="92%"
                              height="300%"
                              dataFormat="JSON"
                              dataSource={mountChartMultLine(
                                data.cashFlowYear,
                                "Ponto de equilíbrio",
                                data.averagePaid
                              )}
                            />
                          )
                        }
                      >
                        Expandir
                      </Button>
                    </Space>
                    <ReactFusioncharts
                      type="msline"
                      width="92%"
                      height="85%"
                      dataFormat="JSON"
                      dataSource={mountChartMultLine(
                        data.cashFlowYear,
                        "Ponto de equilíbrio",
                        data.averagePaid
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div className="container-card">
                  <div
                    className="card-default"
                    style={{
                      minHeight: "340px",
                      maxHeight: "340px",
                      overflow: "auto",
                    }}
                  >
                    <Table
                      size="small"
                      columns={columnsBalance}
                      pagination={false}
                      dataSource={data.cashFlowYear}
                      title={() => (
                        <Space>
                          <div>Ponto de equilíbrio</div>
                          <Button
                            type="link"
                            onClick={() =>
                              showConfirm(
                                "Ponto de equilíbrio",
                                <Table
                                  size="small"
                                  columns={columnsBalance}
                                  pagination={false}
                                  dataSource={data.cashFlowYear}
                                />
                              )
                            }
                          >
                            Expandir
                          </Button>
                          <CSVLink
                            filename={"Ponto de equilíbrio.csv"}
                            data={data.cashFlowYear}
                            headers={columnsBalance}
                          >
                            Baixar
                          </CSVLink>
                        </Space>
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
                          */}
    </div>
  );
};
export default KpiCashFlowV2;
